import { render } from "./DirectoryDetailView.vue?vue&type=template&id=1a0c72da&scoped=true&ts=true"
import script from "./DirectoryDetailView.vue?vue&type=script&lang=ts"
export * from "./DirectoryDetailView.vue?vue&type=script&lang=ts"

import "./DirectoryDetailView.vue?vue&type=style&index=0&id=1a0c72da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0c72da"]])

export default __exports__